import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "./CSV.module.sass";
import { Range, getTrackBackground } from "react-range";
import Checkbox from "../../../components/Checkbox";
import { CSVLink } from "react-csv";
import { UseApi } from "../../../hooks/use-api";
import { GetUsers } from "../../../Services/lib/admin";
import Loader from "../../../components/Loader";
import customers from "../../../i11/Customers";
import { useUser } from "../../../context";

const STEP = 5;
const MIN = 0;

const CSVSettings = ({ count, close }) => {
	const { locale } = useUser();
	const csvLinkEl = useRef();
	const filters = [
		{
			column: "userName",
			title: "User Name",
		},
		{
			column: "firstName",
			title: "First Name",
		},
		{
			column: "lastName",
			title: "Last Name",
		},
		{
			column: "profilePicture",
			title: "Profile Picture",
		},
		{
			column: "email",
			title: "Email",
		},
		{
			column: "mobileNumber",
			title: "Mobile Number",
		},
		{
			column: "createdAt",
			title: "Create At",
		},
		{
			column: "birthday",
			title: "Birthday",
		},
	];
	const [selectedFilters, setSelectedFilters] = useState([
		...filters.slice(0, filters.length - 2),
	]);
	const [csvData, setCSVData] = useState();
	const [values, setValues] = useState([0, count || 2]);
	const [{ isLoading }, getUsers] = UseApi({
		service: GetUsers,
	});

	const handleChange = (filter) => {
		if (selectedFilters.some((val) => val.column === filter.column)) {
			setSelectedFilters(
				selectedFilters.filter((x) => x.column !== filter.column)
			);
		} else {
			setSelectedFilters((selectedFilters) => [...selectedFilters, filter]);
		}
	};

	useEffect(() => {
		// getCSVData();
	}, [csvData]);

	const handleCSVDownasync = async (event, done) => {
		await getUsers({
			offset: 0,
			limit: values[1],
			sortBy: "userName",
			orderBy: "asc",
			isAdmin: "NO",
			q: "",
			isSuspended: true,
		}).then((res) => {
			const sortData = res.users.map((e) => {
				const select = selectedFilters.map((e) => {
					return e.column;
				});
				const convertObj = select.reduce(
					(a, v) => ({ ...a, [v]: e[v] || "" }),
					{}
				);
				return {
					...convertObj,
				};
			});
			setCSVData(sortData);
			csvLinkEl.current.link.click();
		});
	};

	return (
		<div className={styles.settings}>
			<div className={styles.group}>
				<div className={styles.item}>
					<div className={styles.label}>{customers[locale].showing}</div>
					<div className={styles.list}>
						{filters.map((x, index) => (
							<Checkbox
								className={styles.checkbox}
								content={x.title}
								value={selectedFilters.some((obj) => obj.column === x.column)}
								onChange={() => handleChange(x)}
								key={index}
								reverse
							/>
						))}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>{customers[locale].customer}</div>
					<Range
						values={values}
						step={STEP}
						min={MIN}
						max={count || 2}
						onChange={(values) => {
							setValues([0, values[1]]);
						}}
						renderTrack={({ props, children }) => (
							<div
								onMouseDown={props.onMouseDown}
								onTouchStart={props.onTouchStart}
								style={{
									...props.style,
									width: "100%",
									paddingTop: 20,
								}}
							>
								<div
									ref={props.ref}
									style={{
										height: "4px",
										width: "100%",
										borderRadius: "2px",
										background: getTrackBackground({
											values,
											colors: ["#EFEFEF", "#2A85FF", "#EFEFEF"],
											min: MIN,
											max: count,
										}),
										alignSelf: "center",
									}}
								>
									{children}
								</div>
							</div>
						)}
						renderThumb={({ index, props, isDragged }) => (
							<div
								{...props}
								style={{
									...props.style,
									height: "16px",
									width: "16px",
									borderRadius: "50%",
									backgroundColor: "#FFF",
									border: "2px solid #2A85FF",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									boxShadow: "inset 0px 2px 2px #FFFFFF",
								}}
							>
								<div
									style={{
										position: "absolute",
										bottom: "calc(100% + 5px)",
										color: "#fff",
										fontWeight: "600",
										fontSize: "12px",
										lineHeight: "18px",
										fontFamily: "Inter",
										padding: "4px 8px",
										borderRadius: "8px",
										backgroundColor: "#272B30",
									}}
								>
									{values[index].toFixed(0)}
								</div>
							</div>
						)}
					/>
				</div>
				<div className={styles.btns}>
					<button
						className={cn("button-stroke", styles.button)}
						onClick={close}
					>
						{customers[locale].close}
					</button>

					<button onClick={handleCSVDownasync} className="button">
						{isLoading && <Loader />}
						{customers[locale].d_csv}
					</button>

					<CSVLink
						filename="customers.csv"
						ref={csvLinkEl}
						data={csvData || []}
					/>
				</div>
			</div>
		</div>
	);
};

export default CSVSettings;
